import {
  Checkbox as MuiCheckbox,
  Switch as MuiSwitch,
  FormControl,
  FormHelperText,
  Box,
  Typography,
} from '@mui/material';
import { FormikState, FormikHandlers } from 'formik';
import React, { ReactElement, useMemo } from 'react';

const toggleComponents = {
  switch: MuiSwitch,
  checkbox: MuiCheckbox,
};

type Props = Omit<
  React.ComponentProps<typeof MuiCheckbox>,
  'value' | 'onChange' | 'error' | 'size' | 'defaultValue'
> & {
  margin?: React.ComponentProps<typeof FormControl>['margin'];

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  formik: FormikHandlers & FormikState<any>;
  toggleStyle: 'switch' | 'checkbox';
  name: string;
  label: React.ReactNode;
};

const FormikToggle = (props: Props): ReactElement => {
  const { margin, name, label, id, toggleStyle, formik, ...rest } = props;

  const meta = formik.getFieldMeta<boolean>(name);
  const Toggle = useMemo(() => toggleComponents[toggleStyle], [toggleStyle]);

  return (
    <FormControl margin={margin} fullWidth error={!!meta.error}>
      <Box display="flex" alignItems="center" justifyContent="space-between">
        <Typography variant="body2" component="label" htmlFor={id} id={`${id}-label`} color="textSecondary">
          {label}
        </Typography>
        <Toggle
          id={id}
          name={name}
          value={meta.value}
          color="primary"
          checked={meta.value}
          onChange={formik.handleChange}
          {...rest}
        />
      </Box>
      <FormHelperText>{meta.touched && meta.error}</FormHelperText>
    </FormControl>
  );
};

export { FormikToggle };
